const state = {
    data: {},
    edited: {},
    editInfoId: null,
    onEdit: {},
    raw: null,
};

const mutations = {
    ios_banners_init_raw(state, payload) {
        state.raw = payload;
    },

    ios_banners_init(state, payload) {
        state.data = payload;
    },

    ios_banners_edited(state, payload) {
        state.edited = payload;
    },

    ios_banners_onedit(state, payload) {
        state.editInfoId = payload.id;
        state.onEdit = payload;
    },

    ios_banners_clear(state) {
        state.data = {};
        state.edited = {};
        state.editInfoId = null;
        state.onEdit = {};
        state.raw = null;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/global/stores/ios_banners.js